export const USER_MENU = {
  ADMIN_DASHBOARD: 'Admin Dashboard',
  HELP: 'Help',
  PURCHASE_CREDITS: 'Purchase Credits',
  CONTACT_ADMIN: 'Contact Admin',
  LOGOUT: 'Logout',
};
